<div class="form-containerv2">
  <header class="be-section-mb--responsive">
    <h2 class="titlev2">Activate your account</h2>
    <p class="sub-titlev2">
      Check {{ maskedDestination }} and enter 6 digit code to activate account.
    </p>
    <p class="sub-titlev2">
      If you have issues accessing the code, please give us a call at
      <a href="tel:855-282-6353">855-282-6353</a>.
    </p>
  </header>
  <form
    [formGroup]="activateForm"
    (ngSubmit)="activateAccount()"
    class="activate-form"
  >
    <app-be-input-group-reactive
      [beFormGroup]="activateForm"
      [beFormControl]="activateForm.controls['confirmationCode']"
      beFormControlName="confirmationCode"
      inputLabel="Confirmation Code"
      inputPlaceholder="Confirmation Code *"
      inputMaxLength="6"
      variant="sm"
    >
      <app-be-helper-text
        >{{ activateForm.controls['confirmationCode'].value.length }} /
        6</app-be-helper-text
      >
    </app-be-input-group-reactive>
    <div class="be-section-mt--responsive be-section-mb--responsive">
      <app-api-btn
        [isSubmitting]="isLoading"
        [isDisabled]="activateForm.invalid"
        btnId="activateAccountBtn"
        >Activate Account</app-api-btn
      >
    </div>
  </form>
  <app-verification-tips-panel
    (onResendConfirmationCode)="resendConfirmationCode()"
  ></app-verification-tips-panel>
</div>
